import React from 'react';
import { Box, Drawer } from '@mui/material';
import ListMenuItems from './ListMenuItems';
import useSidebarHook from './useSidebarHook';
import { useTelasSemMenu } from '../../../hooks/TelasSemMenu';

const Sidebar = ({
  menuOpen,
  handleDrawerToggle,
  drawerWidth,
  window,
  escopoAcesso,
  departamentoSelecionado,
  setScrIframe,
  setEscopoAcesso,
  setDepartamentoSelecionado,
  onlySmallScreen,
  setDrawerWidth
}) => {
  const {
    container,
    expanded,
    setExpanded,
    menuExpandido,
    mostrarSideBar,
    handleChangeAccordion,
    handleOnClickFecharMenu,
    onMouseEnterSidebar,
    onMouseLeaveSidebar
  } = useSidebarHook({
    departamentoSelecionado,
    menuOpen,
    drawerWidth,
    window,
    onlySmallScreen,
    setDrawerWidth,
    handleDrawerToggle
  });

  return (
    <Box
      component="nav"
      aria-label="mailbox folders"
      className={`sidebar-nav-oneshell ${useTelasSemMenu() ? 'width-0' : ''} ${mostrarSideBar ? '' : 'display-none'}`}
      onMouseEnter={onMouseEnterSidebar}
      onMouseLeave={onMouseLeaveSidebar}
    >
      {menuOpen && <Box className="backdrop-sidebar" onClick={handleOnClickFecharMenu} />}

      <Drawer
        container={container}
        variant="permanent"
        open={menuExpandido}
        onClose={handleDrawerToggle}
        className="sidebar-nav-oneshell"
        ModalProps={{
          keepMounted: true
        }}
      >
        <ListMenuItems
          menuOpen={menuExpandido}
          expanded={expanded}
          setExpanded={setExpanded}
          handleDrawerToggle={handleDrawerToggle}
          escopoAcesso={escopoAcesso}
          handleChangeAccordion={handleChangeAccordion}
          setScrIframe={setScrIframe}
          setEscopoAcesso={setEscopoAcesso}
          departamentoSelecionado={departamentoSelecionado}
          setDepartamentoSelecionado={setDepartamentoSelecionado}
        />
      </Drawer>
    </Box>
  );
};

export default Sidebar;
